export const environment = {
  production: false,
  name: 'Dev',
  // API: 'https://localhost:44328/api',
  API: 'https://parceirousbff.api.hml.pjus.com.br/api',
  V1: 'v1',
  CLARITY: 'ruqcoq53tm',
  licenseKey: 'NRJS-82f7743c7a343504d2e',
  applicationID: '1103417858',
  accountID: '4504660',
  trustKey: '4504660',
  agentID: '1103417858',

  rotaCotacao: 'area-parceiro'
};
